"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function FormViewers(_a) {
    var video = _a.video, toggleVideoOption = _a.toggleVideoOption;
    return react_1.default.createElement(storybook_1.Cards.Card, { className: 'storybook-livestreams-form-chat mb-4' },
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement("div", { className: 'storybook-livestreams-form-chat-wrapper' },
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, "Aantal kijkers weergeven"),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(storybook_1.Texts.Span, { className: 'storybook-forms-status-label' }, "Weergeven"),
                    react_1.default.createElement(storybook_1.Forms.Toggle, { value: video.options.viewers, onClick: function () { return toggleVideoOption('viewers'); } }))),
            react_1.default.createElement(storybook_1.Texts.Small, { className: 'storybook-livestreams-form-chat-text' }, "Geef aan je kijkers weer hoeveel de stream wordt bekeken.")));
}
exports.default = FormViewers;
